import { Component, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AppCommonModule } from 'src/app/common.module';
import { MainDialogComponent } from 'src/app/components/main-dialog/main-dialog.component';
import { ContractorIntroComponent } from './intro.component';

@Component({
  selector: 'app-contractor-intro-dialog',
  templateUrl: './intro.dialog.html',
  styleUrls: ['./intro.dialog.scss'],
  imports: [
    AppCommonModule,
    MainDialogComponent,
    ContractorIntroComponent,
  ],
})
export class ContractorIntroDialogComponent {
  private _modal = inject(ModalController);

  dismiss() {
    this._modal.dismiss();
  }
}
